import { ReactNode } from 'react'

const ImageOptionsContainer = ({ children }: { children: ReactNode }) => {
  return <div className="grid grid-cols-4 gap-6 md:grid-cols-2">{children}</div>
}

export default ImageOptionsContainer
